'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

var useSort = function (initialState) {
    var _a = React.useState(initialState), sortInfo = _a[0], setSortInfo = _a[1];
    var updateSortInfo = React.useCallback(function (id) {
        var newSort = { column: id, order: 'asc' };
        if (id === sortInfo.column) {
            newSort.order = sortInfo.order === 'asc' ? 'desc' : 'asc';
        }
        setSortInfo(newSort);
    }, [sortInfo]);
    return [sortInfo, updateSortInfo];
};

module.exports = useSort;
